module.exports = __webpack_public_path__ + "img/vodacom-basketball-background-mobile.bc11596d.png";